import { T } from "@tldraw/validate"
import {
  TLDefaultSizeStyle,
  TLDefaultFontStyle,
  TLDefaultTextAlignStyle,
  TLRichText,
  TLBaseShape,
  RecordProps,
  DefaultSizeStyle,
  DefaultFontStyle,
  DefaultTextAlignStyle,
  richTextValidator,
  createShapePropsMigrationIds,
  createShapePropsMigrationSequence,
  toRichText,
  TLPageId,
} from "tldraw"
import { Color, Expr } from "./Expr"
import { VisibilityAndOpacity } from "./CustomDrawShape"

/** @public */
export interface LDTextShapeProps {
  // color: Expr<Color>
  size: TLDefaultSizeStyle
  textAlign: TLDefaultTextAlignStyle
  w: number
  richText: TLRichText
  scale: number
  autoSize: boolean
  layer: string
  parameterValues: VisibilityAndOpacity & {
    strokeColor: Expr<Color>
    text: Expr<string>
    font: Expr<TLDefaultFontStyle>
  }
}

/** @public */
export type LDTextShape = TLBaseShape<"text2", LDTextShapeProps>

/** @public */
export const textShapeProps: RecordProps<LDTextShape> = {
  //color: T.any,
  size: DefaultSizeStyle,
  textAlign: DefaultTextAlignStyle,
  w: T.nonZeroNumber,
  richText: richTextValidator,
  scale: T.nonZeroNumber,
  autoSize: T.boolean,
  layer: T.string,
  parameterValues: T.any,
}

const Versions = createShapePropsMigrationIds("text2", {
  RemoveJustify: 1,
  AddTextAlign: 2,
  AddRichText: 3,
})

export { Versions as textShapeVersions }

/** @public */
export const textShapeMigrations = createShapePropsMigrationSequence({
  sequence: [
    {
      id: Versions.RemoveJustify,
      up: (props) => {
        if (props.align === "justify") {
          props.align = "start"
        }
      },
      down: "retired",
    },
    {
      id: Versions.AddTextAlign,
      up: (props) => {
        props.textAlign = props.align
        delete props.align
      },
      down: (props) => {
        props.align = props.textAlign
        delete props.textAlign
      },
    },
    {
      id: Versions.AddRichText,
      up: (props) => {
        props.richText = toRichText(props.text)
        delete props.text
      },
      // N.B. Explicitly no down state so that we force clients to update.
      // down: (props) => {
      // 	delete props.richText
      // },
    },
  ],
})
